import { CreateAttendeeCommand } from "@aws-sdk/client-chime-sdk-meetings";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";

const { error: errorToast } = ToasterWithMessage();

export const createChimeAttendee = async (MeetingId: string, ExternalUserId: string) => {
  try {
    const chimeClient = await getChimeClient();

    console.log("[Log] Creating attendee for meeting:", MeetingId, "with user:", ExternalUserId);

    const attendeeInput = {
      MeetingId,
      ExternalUserId,
    };

    // Create an attendee for the meeting
    const attendeeResponse = await chimeClient.send(new CreateAttendeeCommand(attendeeInput));
    console.log("[Log] Attendee created successfully:", attendeeResponse);

    // Check if attendee ID is present in the response
    if (!attendeeResponse.Attendee || !attendeeResponse.Attendee.AttendeeId) {
      errorToast("Attendee ID is missing in the response.");
      throw new Error("Attendee ID is missing in the response.");
    }

    return attendeeResponse;
  } catch (error: any) {
    if(error?.message?.includes('Meeting') && error?.message?.includes('not found')) {
      errorToast("Meeting not found");
    }else{
      errorToast(error.message);
    }
    console.error("[Log] Failed to create attendee:", error.message || error);
  }
};
